import React from 'react';
import TopicLayout from '../Js_files/Topic_layout';
import { useEffect, useState } from 'react';
import EnrollForm from './Enroll';
import Navbar from './Navbar';
import Footer from './Footer';


const File7 = () => {
   const [showScrollTop, setShowScrollTop] = useState(false);
    const [showForm, setShowForm] = useState(false); // ✅ Control form visibility
             useEffect(() => {
          const handleScroll = () => {
            setShowScrollTop(window.scrollY > 200);
          };
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
        }, []);
      
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
  const topics = [
    {
      title: "Video Production",
      description: "Video shooting, editing, post-production, and storytelling techniques for various media formats.",
      tags: ["Video Editing", "Cinematography", "Post-Production", "Storytelling"]
    },
    {
      title: "3D Modeling & Animation",
      description: "3D modeling, character animation, visual effects, and rendering for games, films, and visualization.",
      tags: ["3D Modeling", "Animation", "Rendering", "VFX", "Character Design"]
    },
    {
      title: "Audio Production",
      description: "Sound recording, editing, mixing, and audio post-production for multimedia projects.",
      tags: ["Audio Recording", "Sound Mixing", "Music Production", "Podcasting"]
    },
    {
      title: "Game Development",
      description: "Game design, programming, asset creation, and interactive media development.",
      tags: ["Game Design", "Unity", "Unreal Engine", "Game Programming", "Level Design"]
    },
    {
      title: "Motion Graphics",
      description: "Animated graphics, visual effects, and motion design for advertising and digital media.",
      tags: ["After Effects", "Motion Design", "Visual Effects", "Typography Animation"]
    },
    {
      title: "Interactive Media",
      description: "Web-based multimedia, interactive installations, and immersive digital experiences.",
      tags: ["Interactive Design", "Web Multimedia", "AR/VR", "User Interaction"]
    }
  ];

  const resources = [
    {
      icon: "🎬",
      title: "Production Software",
      description: "Professional video editing, 3D modeling, and audio production software and tools."
    },
    {
      icon: "🎮",
      title: "Game Engines",
      description: "Unity, Unreal Engine, and other game development platforms and frameworks."
    },
    {
      icon: "🎵",
      title: "Audio Tools",
      description: "Digital audio workstations, sound libraries, and audio processing software."
    },
    {
      icon: "📱",
      title: "Hardware",
      description: "Cameras, microphones, graphics tablets, and other multimedia production equipment."
    }
  ];

  const careerPaths = [
    {
      title: "Video Editor",
      description: "Edit and produce video content for films, television, online media, and marketing campaigns.",
      skills: ["Video Editing Software", "Storytelling", "Color Correction", "Audio Sync"]
    },
    {
      title: "3D Artist",
      description: "Create 3D models, animations, and visual effects for games, films, and architectural visualization.",
      skills: ["3D Modeling", "Texturing", "Animation", "Rendering", "Software Proficiency"]
    },
    {
      title: "Game Developer",
      description: "Design and develop video games, from concept to final product, including programming and asset creation.",
      skills: ["Game Programming", "Game Design", "Unity/Unreal", "Problem Solving"]
    },
    {
      title: "Motion Graphics Designer",
      description: "Create animated graphics and visual effects for advertising, film, and digital media.",
      skills: ["After Effects", "Motion Design", "Typography", "Visual Storytelling"]
    }
  ];

  return (
    <>
      <Navbar onEnrollClick={() => setShowForm(true)}/>
    <TopicLayout
      title="Multimedia Technology"
      icon="🎬"
      color="#FFB6C1"
      description="Discover digital media creation, graphics design, and animation techniques. Master video editing, 3D modeling, and the tools that bring creative visions to life in the digital realm."
      topics={topics}
      resources={resources}
      careerPaths={careerPaths}
    />
    <Footer/>
     <a
        href="https://wa.me/9042857947"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      {/* Scroll to Top */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}

      {/* ✅ Enroll Form Overlay */}
      {showForm && <EnrollForm onClose={() => setShowForm(false)} />}
    </>
  );
};

export default File7;